import { render, staticRenderFns } from "./detalhe_compra.vue?vue&type=template&id=80cfc4da&scoped=true&"
import script from "./detalhe_compra.vue?vue&type=script&lang=js&"
export * from "./detalhe_compra.vue?vue&type=script&lang=js&"
import style0 from "./detalhe_compra.vue?vue&type=style&index=0&id=80cfc4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cfc4da",
  null
  
)

export default component.exports